import { Icon, IconName, IconSize } from '@ardoq/icons';
import styled from 'styled-components';
import { AppliedSettingsRow } from './AppliedSettingsRow';
import { Tag } from '@ardoq/status-ui';
import { ComponentAndReferenceTypesSettings } from './types';
import { WithPopover } from '@ardoq/popovers';
import { colors } from '@ardoq/design-tokens';
import { FlexBox } from '@ardoq/layout';
import { pluralize } from '@ardoq/common-helpers';
import { t, type I18nLocale } from '@ardoq/i18n';
import { tagStyles } from './atoms';

const TagWrapper = styled(Tag)`
  ${tagStyles}
`;

type Entity = 'component' | 'reference';

const EntityTag = ({
  entity,
  count,
  iconName,
}: {
  entity: Entity;
  count: number;
  iconName: IconName;
}) => {
  const PopoverContent = () => (
    <FlexBox align="center" gap="xsmall">
      <Icon
        iconName={iconName}
        iconSize={IconSize.SMALL}
        color={colors.grey500}
      />
      <div>
        {count} {entity} {pluralize('type', count)}
      </div>
    </FlexBox>
  );

  return (
    <WithPopover key={entity} content={PopoverContent}>
      <TagWrapper iconName={iconName} label={count.toString()} key={entity} />
    </WithPopover>
  );
};

type Props = {
  settings: ComponentAndReferenceTypesSettings;
  i18nLocale: I18nLocale;
};
export const ComponentAndReferenceTypes = ({ settings, i18nLocale }: Props) => {
  const { componentTypesCount, referenceTypesCount, onEditClick } = settings;

  const tags = [
    EntityTag({
      entity: 'component',
      count: componentTypesCount,
      iconName: IconName.COMPONENT,
    }),
    EntityTag({
      entity: 'reference',
      count: referenceTypesCount,
      iconName: IconName.REFERENCE,
    }),
  ];

  return (
    <AppliedSettingsRow
      label={t(
        i18nLocale,
        'appLayout:componentAndReferenceTypesLabel',
        'Component and reference types'
      )}
      tags={tags}
      icon={IconName.ACCOUNT_TREE}
      onEditClick={onEditClick}
      i18nLocale={i18nLocale}
    />
  );
};
